import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { ReestrChangeWorkerDto } from '../../_dto/_reestr/ReestrChangeWorkerDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiChangeWorkerReestr = async (dto: ReestrChangeWorkerDto) => {
  const params: IApiParams = {
    url: '/reestr/changeWorker.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'PUT', dto);
};
